/**
 * @file Server-side entry point for the calendar library.
 * This module requires Node.js and contains database operations.
 */

// Export all shared types and utilities (server can use these too)
export * from '../shared/types';
export * from '../shared/utils';
export * from '../shared/constants';
export * from '../shared/enums';

// Export database entities
export * from './database/entities';

// Export server services
export * from './services/events';
export * from './services/ics';

// Export server-side validation
export * from './validation'; 